import { useSearchParams } from 'react-router-dom';

import { Link, useMatch, useResolvedPath } from 'react-router-dom';
import './NavBar.css';
import WebSiteIcon from '../WebSiteIcon/WebSiteIcon';
import axios from 'axios';

import WebsiteLogo from '../../aImages/_logo.png';
import { useEffect } from 'react';
import { useState, useRef } from 'react';

// import { useCookies } from 'react-cookie';
import { useNavigate, useLocation } from 'react-router-dom';

import { getUserFromCookie } from '../../Javascript_Functions_to_export/Utils';

import Cookie from 'js-cookie';
import { toast } from 'react-toastify';

//import io from "socket.io-client";
import socket from '../../SocketConnection/Socket';

const NavBar = ({ toggleSideBar, flag, _logo, GoBackward }) => {
//const NavBar = ({ toggleSideBar, flag, _logo }) => {
//const NavBar = ({ toggleSideBar }) => {

    //console.log("in navbar.js"); 

    let navigate = useNavigate();
    const loc = useLocation();

    const [companyLogo, setCompanyLogo] = useState(null);

    const Logged_In_AdminIcon = "data:@file/jpeg;base64,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";
    const Logged_In_Icon = 'data:@file/png;base64,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';

    //"Continue with Google" button
    // useEffect(() => {
    //     const params = new URLSearchParams(loc.search);
    //     const loggedIn = params.get("loggedIn");
    //     //console.log("loggedIn:", loggedIn, typeof loggedIn);

    //     if (loggedIn) {
    //         sessionStorage.setItem('Logo', 'data:@file/png;base64,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');
    //         // fetchUser();
    //         // set sessionStorage("logo")
    //     }
    // }, [loc.search]); // 👈 dependency
    

    const [currentUser, setCurrentUser] = useState(null);

    const [onlineUsers, setOnlineUsers] = useState(0);
    const [onlineUsersDetails, setOnlineUsersDetails] = useState([]);


    useEffect(() => {
        //console.log("user", getUserFromCookie(Cookie.get('adminToken')));
        var adminUser = getUserFromCookie(Cookie.get('adminToken'));
        if (adminUser && parseInt(adminUser.AccountType) === 2) // if admin
            document.title = `(${onlineUsers}) hiremeworld`; // (1) hiremeworld
        else
            document.title = `hiremeworld`;
        
    }, [currentUser, onlineUsers]);


    //let soundEnabled = false;
    // // This useEffect is used to show the onlineUsers
    useEffect(() => {

        // setTimeout(() => {
        //     throw new Error("Test runtime crash!");
        // }, 1000); // 1 second after component mounts

        socket.emit("pageVisit", 
            { 
                page: "NavBar", 
                isLoggedIn: Cookie.get('token') ? true : false,
                username: Cookie.get('token') ? getUserFromCookie(Cookie.get('token')).Username : null,
            });
        

        // **************** start
        //const enableSound = () => {
            //soundEnabled = true;
            //console.log("Sound enabled by user interaction.");
        //};

        // Enable on first scroll
        //window.addEventListener("scroll", enableSound, { once: true });

        // Enable on first click
        //window.addEventListener("click", enableSound, { once: true });

        
        // ***************** End



        //     //✅ Create socket inside useEffect

        //     // 1- Client tries to connect, client 
        //     // 2- sends an HTTP request to the mydomain.com/socket.io/?EIO=4&transport=polling&t=O7rU1Jk
        //     const socket = io(process.env.REACT_APP_URL);   // http://localhost:8081

        // The problem was, when I was using it without the "withCredentials: true" attribute.
        // old working code:
        // const socket = io(process.env.REACT_APP_URL, {
        //     withCredentials: true,
        //     transports: ['websocket'],
        //     query:{
        //         username: "Saeed",
        //         isMobile: navigator.userAgentData.mobile
        //     }
        // });


        socket.on('connect', () => {
            //console.log('soundEnabled', soundEnabled);
            // You can emit events or perform actions upon connection if needed
            //if (soundEnabled) {
                //const audio = new Audio('/ww.mp3');
                //audio.play().catch((error) => { console.error("Error playing sound:", error); });
            //}
        });

        socket.on("onlineUsers", (count) => {
            //axios.get(`http://localhost:8081/api/playNotification`);
            //console.log("a new render");
            setOnlineUsers(count);
            //setOnlineUsersDetails([...onlineUsersDetails, { id: 0 }])
            //window.dispatchEvent(new CustomEvent("online-users-details", { detail: [1,4,5] }))
        });

        //socket.on("onlineUsersDetails", (det) => {
            //window.dispatchEvent(new CustomEvent("online-users-details", { detail: det }))
        //});
        

        //socket.on("playSound", async () => {
            // try {
            //     await fetch("http://localhost:8080/api", { method: "GET" });
            // } catch (err) {
            //     console.error(err);
            // }
        //});

        //socket.on("playSound", () => {
            
            //const audio = new Audio('/New_Visitor.mp3');
            //audio.play().catch((error) => { console.error("Error playing sound:", error); });
        //});

        return () => {
            socket.disconnect();

            
            //window.removeEventListener("scroll", enableSound);
            //window.removeEventListener("click", enableSound);
        
        };
    }, []);




    useEffect(() => {
        if(sessionStorage.getItem('Logo')) {
            if(sessionStorage.getItem('Logo') == "null" || sessionStorage.getItem('Logo') == "undefined")
                setCompanyLogo(null);
            else {
                setCompanyLogo(sessionStorage.getItem('Logo'));
                //console.log("localStorag.getItem('Logo'):", localStorag.getItem('Logo'));
            }
        }

        //console.log("in navbar");

        if(loc && 
           loc.state && 
           loc.pathname === '/login') {
            if(loc.state.LastVisitedPage === '/login') { 
                    GoBackward(true);
                    //console.log("navbar send");
                    // last solution is window.href = 'login'
                    //window.location.href = process.env.REACT_APP_ORIGIN + "/login";
            }
            else
                    GoBackward(false);
        }
    });

    //console.log("logo=", companyLogo);
    //   const Navigate = (path) => {
    //     //history(path);
    //     window.location.href = "http://localhost:X000" + path;
    //   }
    // const changeVisibility = () => {
    //     toggleSideBar(!flag);
    // }


    //console.log("location = ", loc);

    axios.defaults.withCredentials = true;

    const logout = () => {

        //Cookie.remove('token');
        
        show_hideLogoutNProfile();

        axios.get(`${process.env.REACT_APP_URL}/logout`, { withCredentials: true })
        .then(res => {
            if(sessionStorage.getItem('Logo')) {
                //console.log("deleting Logo");
                sessionStorage.removeItem('Logo');
            }

            //return;
            // So once the user logout. refresh the page

            if(!loc || !loc.pathname)
                //window.location.href = "http://localhost:300x";
                window.location.href = process.env.REACT_APP_ORIGIN;
            else {
                if(loc.pathname === '/admin')
                    //window.location.href = "http://localhost:300x";
                    window.location.href = process.env.REACT_APP_ORIGIN;
                else  // common section (to write inside a class)
                    if(loc.pathname == "/search" && localStorage.getItem('search'))
                        //window.location.href = "http://localhost:300x" + loc.pathname + localStorage.getItem('search');
                        window.location.href = process.env.REACT_APP_ORIGIN + loc.pathname + localStorage.getItem('search');
                    else {
                        if(loc.pathname === '/signup')
                            //window.location.href = "http://localhost:300x";    
                            window.location.href = process.env.REACT_APP_ORIGIN;    
                        else {
                            //console.log("nav bar | loc.pathname", loc.pathname);
                            if(loc.pathname.indexOf("/company/details") >= 0 || 
                               loc.pathname.indexOf("/candidate/details") >= 0) {
                                //console.log("to login directly", loc.pathname);
                                window.location.href = process.env.REACT_APP_ORIGIN + "/login";
                            }
                            else    
                                window.location.href = process.env.REACT_APP_ORIGIN + loc.pathname;
                        }
                    }
            } 
        })
        .catch(err => {
            toast('error', err);
        })

        return;

        // So once the user logout. refresh the page
        if(!loc || !loc.pathname)
            //window.location.href = "http://localhost:300x";
            window.location.href = process.env.REACT_APP_ORIGIN;
        else {
            if(loc.pathname === '/admin')
                //window.location.href = "http://localhost:300x";
                window.location.href = process.env.REACT_APP_ORIGIN;
            else  // common section (to write inside a class)
                if(loc.pathname == "/search" && localStorage.getItem('search'))
                    //window.location.href = "http://localhost:300x" + loc.pathname + localStorage.getItem('search');
                    window.location.href = process.env.REACT_APP_ORIGIN + loc.pathname + localStorage.getItem('search');
                else {
                    if(loc.pathname === '/signup')
                        //window.location.href = "http://localhost:300x";    
                        window.location.href = process.env.REACT_APP_ORIGIN;    
                    else
                        //window.location.href = "http://localhost:300x" + loc.pathname;
                        window.location.href = process.env.REACT_APP_ORIGIN + loc.pathname;
                }
        }

        return;

        var headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');

        //fetch('http://localhost:808x/logout', {
        fetch(`${process.env.REACT_APP_URL}/logout`, {
            method: 'GET',
            mode: 'no-cors',
            redirect: 'follow',
            credentials: 'include',
            headers: headers
        })
        .then((res) => {
            //toast("You have logged out successfully");
            
            // We commented this line, because we want to leave the user in the same page. 
            // and not redirect him to another page
            //navigate('/login');

            //return;

            // So once the user logout. refresh the page

            if(!loc || !loc.pathname)
                //window.location.href = "http://localhost:300x";
                window.location.href = process.env.REACT_APP_ORIGIN;
            else {
                if(loc.pathname === '/admin')
                    //window.location.href = "http://localhost:300x";
                    window.location.href = process.env.REACT_APP_ORIGIN;
                else  // common section (to write inside a class)
                    if(loc.pathname == "/search" && localStorage.getItem('search'))
                        //window.location.href = "http://localhost:300x" + loc.pathname + localStorage.getItem('search');
                        window.location.href = process.env.REACT_APP_ORIGIN + loc.pathname + localStorage.getItem('search');
                    else {
                        if(loc.pathname === '/signup')
                            //window.location.href = "http://localhost:300x";    
                            window.location.href = process.env.REACT_APP_ORIGIN;    
                        else
                            //window.location.href = "http://localhost:300x" + loc.pathname;
                            window.location.href = process.env.REACT_APP_ORIGIN + loc.pathname;
                    }
            } 
        })
    }

    const screenRef = useRef(null);
    const profileRef = useRef(null);

    const mobileProfileRef = useRef(null);

    //const [currentUser, setCurrentUser] = useState(null);
    
    //console.log("currentUser has been set", getUserFromCookie(document.cookie));
    //console.log("document.cookie", document.cookie);
 
    //console.log("currentUser has been set", getUserFromCookie(Cookie.get('token')));   //  new code

    useEffect(() => {
        
        //console.log("currentUser has been set 1", getUserFromCookie(Cookie.get('token')));
        if(Cookie.get('token') && !currentUser) {
            setCurrentUser(getUserFromCookie(Cookie.get('token'))); 
        }
        if(Cookie.get('adminToken') && !currentUser) {
            setCurrentUser(getUserFromCookie(Cookie.get('adminToken'))); 
            //console.log("currentUser has been set 1", getUserFromCookie(Cookie.get('adminToken')));
        }

        // If user closes the tab || 
        //         closes the browser ||
        //         or open a new tab
        // before the session expired
        if(Cookie.get('token') && !sessionStorage.getItem('Logo')) {
            var _userId = getUserFromCookie(Cookie.get('token')).ID;
            if(parseInt(getUserFromCookie(Cookie.get('token')).AccountType) === 1) {

                axios.get(`${process.env.REACT_APP_URL}/company/${_userId}`)
                .then(res => {
                    if(sessionStorage.getItem('Logo'))
                        sessionStorage.removeItem('Logo');

                    //console.log("Setting Logo");
                    sessionStorage.setItem('Logo', res.data[0].Logo);
                    setCompanyLogo(res.data[0].Logo);
                })
                .catch(err => {
                    toast('error', err);
                })
            }
        }

        //console.log("in navbar");
        //console.log("currentUser has been set 3", Cookie.get('token'));
        
    });
    //document.cookie = "token=user";
    //console.log("currentUser has been set", document.cookie);

    useEffect(() => {
        document.addEventListener("mousedown", handleOutsideClick);

       

        //window.scrollTo(0, 0);
    }, []);
    
    const show_hideLogoutNProfile = () => {
        var logoutBox = document.getElementById('logout-profile');
        var profileCaret = document.getElementById('profile-caret');

        if(!logoutBox || !profileCaret)
            return;

        let width = window.innerWidth;

        if(!logoutBox.classList.contains('opened')) {
            logoutBox.classList.add('opened');
            logoutBox.style.visibility = 'visible';

            profileCaret.style.transform = 'rotate(180deg)';
            profileCaret.style.transition = 'transform 0.1s';

            // if user uses mobile
            // if(width <= 500) {
            //     // stop the scrolling
            //     if (typeof window != 'undefined' && window.document) {
            //         document.body.style.overflow = 'hidden';
            //     }
            // }

        }
        else {
            profileCaret.style.transform = 'rotate(0deg)';
            profileCaret.style.transition = 'transform 0.1s';

            logoutBox.classList.remove('opened');
            logoutBox.style.visibility = 'hidden';

            // if user uses mobile
            // if(width <= 500) {
            //     // run the scrolling
            //     document.body.style.overflow = 'unset';
            // }
        }
    }

    const handleOutsideClick = (e) => {

        let width = window.innerWidth;
        // if user uses desktop
        if(width > 500) {
            if (screenRef.current && !screenRef.current.contains(e.target) &&
                profileRef.current && !profileRef.current.contains(e.target)) {

                var logoutBox = document.getElementById('logout-profile');
                var profileCaret2 = document.getElementById('profile-caret');

                if(!logoutBox || !profileCaret2)
                    return;
                
                profileCaret2.style.transform = 'rotate(0deg)';
                profileCaret2.style.transition = 'transform 0.1s';

                logoutBox.classList.remove('opened');
                logoutBox.style.visibility = 'hidden';
            }
        }
        else { // user uses mobile
            if (screenRef.current && !screenRef.current.contains(e.target) &&
                mobileProfileRef.current && !mobileProfileRef.current.contains(e.target)) {

                var logoutBox2 = document.getElementById('logout-profile');
                var profileCaret = document.getElementById('profile-caret');

                if(!logoutBox2 || !profileCaret)
                    return;
                
                profileCaret.style.transform = 'rotate(0deg)';
                profileCaret.style.transition = 'transform 0.1s';

                logoutBox2.classList.remove('opened');
                logoutBox2.style.visibility = 'hidden';

                // run the scrolling
                //document.body.style.overflow = 'unset';
                
            }
        }
    }

    const resetLocalStorage_Mobile = (_children) => {
        //debugger;
        if(_children.toLowerCase() === 'search for a job')
            if(localStorage.getItem('search'))
                localStorage.removeItem('search');
        else 
            if(_children.toLowerCase() === 'log in') {
                //console.log("refresh");
                //window.location.href = process.env.REACT_APP_ORIGI + "/login";
            }
    }


    return (
    
        <div className='navbar'>
            <span className='img-span'>
                <img src={ WebsiteLogo } 
                    alt="logo" 
                    style={{ zIndex: '80', 
                            width: '45px',
                            height: '40px',
                            position: 'relative',
                            top: '10px',
                            left: '120px',
                            //left: '75px',
                    }} />
            </span> 
            { 
                currentUser && currentUser.AccountType === 2 && 
                <span style={{ 
                    zIndex: '80', 
                    width: '85px',
                    height: '40px',
                    position: 'relative',
                    top: '20px',
                    left: '-20px',
                    fontSize: '20px',
                    fontWeight: '600',
                    color: 'red',
                    //border: "solid 1px black"
                    }}>
                    
                    <span id="online-users-number">
                        { onlineUsers }
                    </span>
                    
                    {/* <div style={{
                        display: "inline-flex",
                        alignItems: "center",
                        border: "solid 1px"
                    }}> */}
                    { 
                        // Array.from({ length: onlineUsers }, (_, i) => (
                        //     <div key={i}
                        //     style={{
                        //         width: "40px",
                        //         height: "40px",
                        //         border: "solid 1px black",
                        //         borderRadius: "50%",
                        //         backgroundColor: "#e4fde4",
                        //         display: "inline-flex",
                        //         alignItems: "center",
                        //         justifyContent: "center",
                        //         color: "white",
                        //         fontWeight: "bold",
                        //         marginRight: "-15px",
                        //         }}>
                        //         <i className="fa fa-user" style={{color: "green"}} aria-hidden="true"></i>
                        //     </div>
                        // ))
                        
                        onlineUsers >= 2 ? 
                        <i className="fa fa-users" style={{color: "green"}} aria-hidden="true"></i> : 
                        <i className="fa fa-user" style={{color: "green"}} aria-hidden="true"></i>
                    }
                    {/* </div> */}
                </span>
            }
            
            {/* <div className='name-div' style={{ 
                color: 'rgb(2 54 253)',
                display: 'flex',
                alignItems: 'center',
                position: 'absolute',
                left: '190px',
                // top: '-3px',
                fontSize: '25px',
                fontWeight: '700',
                height: '60px'
            }}>
                Hire Me World
            </div> */}

            {/* <div id='logout-profile' style={{ visibility: 'hidden' }} ref={ screenRef }> */}
            {/* <div id='logout-profile' style={{ display: "none" }} ref={ screenRef }> */}
            <div id='logout-profile' className="logout" ref={ screenRef }>

                {
                    // Only if the account is a company or admin, show the "Profile" link
                    currentUser && (currentUser.AccountType === 1 || currentUser.AccountType === 2) ?
                    <div className="profile-row">
                        <div className="profile-logo">
                            <i className="fa fa-user" aria-hidden="true"></i>
                        </div>
                        <div className="profile-title" onClick={ show_hideLogoutNProfile } >
                            <Link to={`/company/details/${ currentUser.ID }`}
                                  state={{ LastVisitedPage: '/company/details/' + currentUser.ID }}>
                                Profile
                            </Link>
                        </div>
                    </div> : 
                    
                    // ''
                    
                    // Only if the account is a candidate, show the "Profile" link as well
                    currentUser && 
                    // (currentUser.Username === "bbb" || 
                    //  //currentUser.Username === "saeed1" ||
                    //  currentUser.Username === "sub1" ||
                    //  currentUser.Username === "plan 1_1" ||
                    //  currentUser.Username === "plan 2_1" ||
                    //  currentUser.Username === "plan 3_1" ||
                    //  currentUser.Username === "plan 1_2" ||
                    //  currentUser.Username === "plan 1_3"
                    // ) &&
                    <div className="profile-row">
                        <div className="profile-logo">
                            <i className="fa fa-user" aria-hidden="true"></i>
                        </div>
                        <div className="profile-title" onClick={ show_hideLogoutNProfile } >
                            <Link to={`/candidate/details/${ currentUser.ID }`}
                                state={{ LastVisitedPage: '/candidate/details/' + currentUser.ID }}>
                                Plans
                            </Link>
                        </div>
                    </div>
                }

                <div className="change-password-row">
                    <div className="change-password-logo">
                        <i className="fa fa-key" aria-hidden="true"></i>
                    </div>
                    <div className="change-password-title" onClick={ show_hideLogoutNProfile } >
                        <Link to="/changepassword" 
                              state={{ LastVisitedPage: '/changepassword' }}>
                            Change Password
                        </Link>
                    </div>
                </div>

                <div className="logout-row">
                    <div className="logout-logo">
                        <i className="fa fa-sign-out" aria-hidden="true"></i>
                    </div>
                    <div className="logout-title" onClick={ logout }>
                        Logout
                    </div>
                </div>
            </div>

            <ul className='laptop'>
                {/* <CustomLink to="/websiteicon">Icon</CustomLink> */}
                
                <CustomLink to="/">Home</CustomLink>
                <CustomLink to="/search">Search For a Job</CustomLink>
                <CustomLink to="/postjob">Post a Job</CustomLink>
                <CustomLink to="/contactus">Contact Us</CustomLink>
                {
                    // !document.cookie ?
                    !currentUser ?
                    <>
                    <CustomLink to="/login">Log In / Sign Up</CustomLink>
                    <li className='no-bg-color' style={{ width: '55px', minWidth: '55px', }}>
                        <div style={{ 
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '50%', 
                            background: 'white', 
                            width: '45px',
                            minWidth: '45px',
                            height: '45px',
                            marginTop: '7px', }}>
                                <i className="fa fa-user" 
                                aria-hidden="true"
                                style={{ color: '#c1c1c1', fontSize: '30px' }} >
                                </i>
                        </div>
                    </li>
                    </>
                    :  // else (=document.cookie exists)
                    <>
                        <li className='no-bg-color' onClick={ show_hideLogoutNProfile } ref={ profileRef }
                            style={{ width: 'fit-content', 
                                     minWidth: '55px', 
                                    //  border: 'solid 1px',
                                     display: 'flex',
                                     flexDirection: 'row',
                                     cursor: 'pointer',
                                     gap: '15px', }}>
                            {/* <div> */}
                                <div 
                                // onClick={ show_hideLogoutNProfile } 
                                // style={{ cursor: 'pointer' }}
                                // ref={ profileRe } 
                                >

                                {
                                    // Admin
                                    currentUser &&
                                    currentUser.AccountType === 2 &&
                                    <img src={ Logged_In_AdminIcon } 
                                        alt='admin' 
                                        style={{ width: '45px', minWidth: '45px', height: '45px' }}/>
                                }
                                {
                                    // Employer has already a logo
                                    currentUser && companyLogo &&
                                    currentUser.AccountType === 1 &&
                                    // <img src={ "/" + companyLogo } 
                                    <img src={ companyLogo } 
                                        alt='logged in profile' 
                                        style={{ width: '45px', 
                                                minWidth: '45px', 
                                                height: '45px', 
                                                marginTop: '7px',
                                                borderRadius: '50%' }}/>
                                }
                                {
                                    // Employer while setting companyLogo for the first time
                                    currentUser && !companyLogo &&
                                    currentUser.AccountType === 1 &&
                                    // <img src='/Logged_In.png'
                                    <img src= { Logged_In_Icon }
                                        alt='logged in profile' 
                                        style={{ width: '45px', 
                                                minWidth: '45px', 
                                                height: '45px',
                                                marginTop: '7px',}}/>
                                }
                                {
                                    // Candidate
                                    currentUser && companyLogo &&
                                    currentUser.AccountType === 0 && 
                                    // <img src='/Logged_In.png' 
                                    //<img src= { Logged_In_Icon }
                                    <img src= { companyLogo }
                                        alt='logged in profile' 
                                        style={{ width: '45px', 
                                                minWidth: '45px', 
                                                height: '45px',
                                                marginTop: '7px', }}/>
                                }
                                {/* {
                                    currentUser &&
                                    <span>
                                        Candidate
                                    </span> 
                                } */}
                            </div>

                            {   currentUser &&
                                <div style={{ display: 'flex', 
                                    flexDirection: 'row', 
                                    alignItems: 'center',
                                    //  marginLeft: '-30px',
                                    marginRight: '10px',
                                    gap: '20px',}}>
                                    <div className='user-hi' 
                                        style={{ fontWeight: 'normal', 
                                                fontSize: '15px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '3px', }}>
                                        <div className='hi-user' style={{ color: 'rgb(59, 71, 78)', }}>
                                            { currentUser && currentUser.Username }
                                        </div>
                                        <div className='hi-type' style={{ color: 'rgb(146 158 165)', fontSize: '14px', }}>
                                            { currentUser && currentUser.AccountType === 2 ? 
                                                "Admin" : 
                                            currentUser && currentUser.AccountType === 1 ?
                                                "Employer account" : "Candidate account"
                                            } 
                                        </div>
                                    </div>
                                    <div className='hi-arrow'>
                                        <i className="fa fa-caret-down" id="profile-caret" 
                                        aria-hidden="true" 
                                        style={{ color: 'rgb(70, 84, 92)', }}></i>
                                    </div>
                                </div>
                            }

                    {/* </div>               */}
                    </li>

                    {/* new feature start */}
                    {/* 
                        <i class="fa fa-caret-down" aria-hidden="true"></i> 
                        <i class="fa fa-caret-up" aria-hidden="true"></i>   
                    */}

                        

                        
                    {/* new feature End */}
                    
                    </>
                }

                {/* https://www.youtube.com/watch?v=SLfhMt5OUPI   @ 15:30  */}

            </ul>

            
            <ul className='mobile'>
                {/* <CustomLink to="/websiteicon">Icon</CustomLink> */}
                
                {/* <CustomLink to="/">
                    <i className="fa fa-home" aria-hidden="true"></i>
                </CustomLink> */}

                <li>
                    <Link to="/" 
                        state={{ LastVisitedPage: loc.pathname, tabIsClicked: true }} 
                        onClick={ () => resetLocalStorage_Mobile("Home") }>
                            <i className="fa fa-home" aria-hidden="true"></i>
                    </Link>
                </li>

                <li>
                    <Link to="/search" 
                        state={{ LastVisitedPage: loc.pathname, tabIsClicked: true }} 
                        onClick={ () => resetLocalStorage_Mobile("Search For a Job") }>
                            <i className="fa fa-search" aria-hidden="true"></i>
                    </Link>
                </li>

                <li>
                    <Link to="/postjob" 
                        state={{ LastVisitedPage: loc.pathname, tabIsClicked: true }} 
                        onClick={ () => resetLocalStorage_Mobile("Post a Job") }>
                            <i className="fa fa-plus-square-o" aria-hidden="true"></i>
                    </Link>
                </li>

                <li style={{ marginBottom: "2px", fontSize: "18px", }}>
                    <Link to="/contactus" 
                        state={{ LastVisitedPage: loc.pathname, tabIsClicked: true }} 
                        onClick={ () => resetLocalStorage_Mobile("Contact Us") }>
                            <i className="fa fa-envelope-o" aria-hidden="true"></i>
                    </Link>
                </li>

                {
                    // !document.cookie ?
                    !Cookie.get('token') && !Cookie.get('adminToken') ?
                     <>
                     {/* <li className='no-bg-color' style={{ width: '55px', minWidth: '55px', }}>
                         <div style={{ 
                             display: 'flex',
                             flexDirection: 'row',
                             alignItems: 'center',
                             justifyContent: 'center',
                             borderRadius: '50%', 
                             background: 'white', 
                             width: '35px',
                             minWidth: '35px',
                             height: '35px',
                             marginTop: '10px', }}>
                                 <i className="fa fa-user" 
                                 aria-hidden="true"
                                 style={{ color: '#c1c1c1', fontSize: '41px' }} >
                                 </i>
                         </div>
                        </li> */}

                        {/* <CustomLink to="/login">
                            <i className="fa fa-sign-in" aria-hidden="true"></i>
                        </CustomLink> */}

                        <li style={{ marginBottom: "2px" }}>
                            <Link to="/login" 
                                state={{ LastVisitedPage: loc.pathname, tabIsClicked: true }} 
                                onClick={ () => resetLocalStorage_Mobile("login") }>
                                    <i className="fa fa-sign-in" aria-hidden="true"></i>
                            </Link>
                        </li>

                    </>
                    :  // else (=document.cookie exists)
                    <li className='no-bg-color' 
                        // style={{ width: '55px', minWidth: '55px', }}
                        >
                        <div onClick={ show_hideLogoutNProfile } 
                             style={{ cursor: 'pointer' }}
                             ref={ mobileProfileRef } >

                            {
                                // Admin
                                currentUser &&
                                currentUser.AccountType === 2 &&
                                <img src={ Logged_In_AdminIcon } 
                                     alt='admin' 
                                     style={{ width: '30px', minWidth: '30px', height: '30px' }}/>
                            }

                            {
                                // Employer has already a logo
                                currentUser && companyLogo &&
                                currentUser.AccountType === 1 &&
                                // <img src={ "/" + companyLogo } 
                                <img src={ companyLogo } 
                                     alt='logged in profile' 
                                     style={{ width: '30px', 
                                              minWidth: '30px', 
                                              height: '30px', 
                                              marginTop: '5px',
                                              borderRadius: '50%' }}/>
                            }
                            {
                                // Employer while setting companyLogo for the first time
                                currentUser && !companyLogo &&
                                currentUser.AccountType === 1 &&
                                // <img src='/Logged_In.png' 
                                <img src= { Logged_In_Icon }
                                     alt='logged in profile' 
                                     style={{ width: '30px', 
                                              minWidth: '30px', 
                                              height: '30px',
                                              marginTop: '5px',}}/>
                            }
                            {
                                // Candidate
                                currentUser && companyLogo &&
                                currentUser.AccountType === 0 && 
                                // <img src='/Logged_In.png' 
                                //<img src= { Logged_In_Icon }
                                <img src= { companyLogo }
                                     alt='logged in profile' 
                                     style={{ width: '30px', 
                                              minWidth: '30px', 
                                              height: '30px',
                                              marginTop: '5px', }}/>
                            }
                        </div>
                    </li>
                }


            </ul>
        </div>

    )
}

const CustomLink = ({ to, children, deleteLocalStorage }) => {
   
    const resolvedPath = useResolvedPath(to);
    const isActive = useMatch({ path: resolvedPath.pathname });
   
    var location = useLocation();

    //console.log("nav bar.js | LastVisitedPage: location.pathname = ", location.pathname);

    // Reset the localStorage just if the user clicks the "Search for a Job" link
    const resetLocalStorage = (_children) => {
        //debugger;
        if(_children.toLowerCase() === 'search for a job')
            localStorage.removeItem('search');
        else 
            if(_children.toLowerCase() === 'log in') {
                //console.log("refresh");
                //window.location.href = process.env.REACT_APP_ORIGI + "/login";
            }
    }


    return(
        <li className={ isActive ? 'active' : '' } >
            <Link to={ to } 
                  state={{ LastVisitedPage: location.pathname, tabIsClicked: true }} 
                  onClick={ () => resetLocalStorage(children) }>
                { children }
            </Link>
        </li>
    );
}

export default NavBar;